import { BrandList } from 'brands/brand-list';
import { Redirect } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { trace } from '@opentelemetry/api';
import { useBrandRedirect } from 'shared/hooks';
import { useAuthState } from 'shared/stores';
import { useEffect } from 'react';

export function BrandsResolver() {
  const authState = useAuthState();
  const user = authState.user.get();

  const [redirect, brands] = useBrandRedirect(user?.insightClaims || '', brands => brands.length === 1);

  useEffect(() => {
    const tracer = trace.getTracer('page-view-trace');
    const span = tracer.startSpan('page', {
      attributes: {
        pageview: 'brands',
      },
    });
    span.end();
  }, []);

  if (redirect) {
    return <Redirect to={ROUTES.getSite(brands[0])} />;
  }

  return <BrandList brands={brands} />;
}
